<script>
import { mergeData } from 'vue-functional-data-merge';

const prefixCls = 'ivu-icon';

export default {
  name: 'IconFunctional',
  functional: true,
  props: {
    type: { type: String, required: true },
    size: { type: [Number, String], default: null },
    color: { type: String, default: null },
  },
  render(createElement, {
    props, data, children,
  }) {
    const { type, color, size } = props;

    const classes = {
      [prefixCls]: true,
      [`${prefixCls}-${type}`]: true,
    };

    const style = {};

    if (size) style['font-size'] = `${size}px`;
    if (color) style.color = color;

    const localData = {
      class: classes,
      style,
    };

    return createElement('i', mergeData(data, localData), children);
  },
};
</script>
